/** Safe in-app return path after login (no open redirects). */
export function isSafeAppPath(path: string | null | undefined): path is string {
  if (!path) return false;
  if (!path.startsWith('/')) return false;
  if (path.startsWith('//') || path.startsWith('/\\')) return false;
  if (path.startsWith('/login')) return false;
  return true;
}

export function loginHrefForCurrentLocation(): string {
  if (typeof window === 'undefined') return '/login';
  const path = `${window.location.pathname}${window.location.search}`;
  if (!isSafeAppPath(path)) return '/login';
  return `/login?next=${encodeURIComponent(path)}`;
}

export function pathFromLoginNext(next: string | null): string {
  return isSafeAppPath(next) ? next : '/';
}
